import { createAsyncThunk } from "@reduxjs/toolkit";
import { TRANSACTION } from "constants/api";
import axios from "utils/http";
import moment from "moment";

export interface ITransactionResponse extends ApiResponse {
  data: ITransactions;
}
export interface ITransactionsArgs extends ReduxAction {
  transactionType: TransactionType;
  page: number;
  queries: ITransactionSearchParams;
  dateQuerries: IDateRangePicker;
}

export interface IVerifyUserArgs extends ReduxAction {
  payload: { phone_number: string };
}

export interface ICreateManualDepositArgs extends ReduxAction {
  payload: ICreateDeposit & { otp_code: string };
  uploadedFile: File;
}

export interface IMaunalTransferArgs extends ReduxAction {
  payload: ICreateTransfer & { otp_code: string };
}

export interface IVerifyUserResponse extends ApiResponse {
  data: IUser;
}

export const fetchTransactions = createAsyncThunk(
  TRANSACTION.LIST,
  async (
    {
      page,
      transactionType,
      queries,
      dateQuerries,
      onFailure,
    }: ITransactionsArgs,
    { rejectWithValue }
  ) => {
    try {
      const searchParams = new URLSearchParams();

      if (Object.values(queries)?.length) {
        Object.entries(queries).forEach(([key, value]) => {
          if (value) {
            searchParams.append(`${key}`, value);
          }
        });
      }

      if (dateQuerries?.from_date && dateQuerries?.to_date) {

        const startDate = moment(dateQuerries?.from_date).format('YYYY-MM-DD');
        const endDate = moment(dateQuerries?.to_date).format('YYYY-MM-DD');

        searchParams.append("from_date", startDate);
        searchParams.append("to_date", endDate);
      }

      const { data }: ITransactionResponse = await axios.get(
        `${TRANSACTION.LIST.replace(
          ":transactionType",
          transactionType
        )}?page=${page}`,
        { params: searchParams }
      );
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const verifyUser = createAsyncThunk(
  TRANSACTION.VERIFY_USER,
  async (
    { payload, onSuccess, onFailure }: IVerifyUserArgs,
    { rejectWithValue }
  ) => {
    try {
      const { data }: IVerifyUserResponse = await axios.post(
        TRANSACTION.VERIFY_USER,
        payload
      );
      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateTransationStatus = createAsyncThunk(
  TRANSACTION.UPDATE_STATUS,
  async (
    { id, statusType, payload, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        TRANSACTION.UPDATE_STATUS.replace(":id", String(id)).replace(
          ":statusType",
          String(statusType)
        ),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updatePendingTransaction = createAsyncThunk<
  unknown,
  IUpdatePendingTransaction,
  { rejectValue: IErrorResponse }
>(TRANSACTION.UPDATE_PENDING, async (payload, { rejectWithValue }) => {
  try {
    return await axios.post(TRANSACTION.UPDATE_PENDING, payload);
  } catch (error) {
    return rejectWithValue(error as IErrorResponse);
  }
});

export const createManualDeposit = createAsyncThunk(
  TRANSACTION.MANUAL_DEPOSIT,
  async (
    { payload, uploadedFile, onSuccess, onFailure }: ICreateManualDepositArgs,
    { rejectWithValue }
  ) => {
    try {
      const newPayload = { ...payload };
      delete newPayload.proof_of_payment;
      const formData = new FormData();
      for (const [key, value] of Object.entries(newPayload)) {
        if (value) {
          formData.append(`${key}`, value as unknown as any);
        }
      }
      formData.append("proof_of_payment", uploadedFile);

      const { message }: ApiResponse = await axios.post(
        TRANSACTION.MANUAL_DEPOSIT,
        formData
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const createManualTranfer = createAsyncThunk(
  TRANSACTION.MANUAL_DEBIT,
  async (
    { payload, onSuccess, onFailure }: IMaunalTransferArgs,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        TRANSACTION.MANUAL_DEBIT,
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
